// extracted by mini-css-extract-plugin
export default {"Search":"styles_Search__frMIK","open":"styles_open__qaP74","searchInput":"styles_searchInput__XLtD4","searchButton":"styles_searchButton__GuTsR"};